/*
 * This file is auto-generated by ./bin/rails stimulus:manifest:update
 * Run that command whenever you add a new controller or create them with
 * ./bin/rails generate stimulus controllerName
 */

import {application} from "./application";

import DialogController from "./dialog_controller";
application.register("dialog", DialogController);

import HotkeysController from "./hotkeys_controller";
application.register("hotkeys", HotkeysController);

import KeepUnreadToggleController from "./keep_unread_toggle_controller";
application.register("keep-unread-toggle", KeepUnreadToggleController);

import MarkAllAsReadController from "./mark_all_as_read_controller";
application.register("mark-all-as-read", MarkAllAsReadController);

import StarToggleController from "./star_toggle_controller";
application.register("star-toggle", StarToggleController);

import StoryRefreshController from "./story_refresh_controller";
application.register("story-refresh", StoryRefreshController);

import UnreadCountController from "./unread_count_controller";
application.register("unread-count", UnreadCountController);
